"use client";

import React, { createContext, useContext } from "react";
import { createPortal } from "react-dom";

/**
 * Where full-screen overlays (annotation, screenshot viewer, replay, mockup
 * overlay) render.
 *
 * They used to portal straight into `document.body`. That escapes the
 * transformed panel, which is the point, but also escapes
 * `.markup-widget-scope` — and every widget style is scoped under that class,
 * so the overlays rendered unstyled. (In the script-tag build it also escaped
 * the Shadow DOM holding the styles.) The host is a node at the scope's root
 * instead: inside the scope, outside the transform.
 */
export const PortalHostContext = createContext<HTMLElement | null>(null);

export const WidgetPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const host = useContext(PortalHostContext);
    if (typeof document === "undefined") return null;
    return createPortal(children, host ?? document.body);
};
